import { Box, Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import html from "../Tech Stacks Images/html.png";
import css from "../Tech Stacks Images/css.png";
import javascript from "../Tech Stacks Images/javascript.png";
import react from "../Tech Stacks Images/react.png";
import TypeScript from '../Tech Stacks Images/Typescript.png'
import MaterialUI from "../Tech Stacks Images/MaterialUI.png";
import ChakraUI from "../Tech Stacks Images/Chakra UI.png";
import NextJS from "../Tech Stacks Images/Nextjs.png"
import node from "../Tech Stacks Images/node.png";
import express from "../Tech Stacks Images/express.png";
import github from "../Tech Stacks Images/github.png";
import mongodb from "../Tech Stacks Images/mongodb.png";
import redux from "../Tech Stacks Images/redux.png";
import VS_Code from "../Tech Stacks Images/VS Code.png";
import CodeSandbox from "../Tech Stacks Images/CodeSandbox.png";
import Netlify from "../Tech Stacks Images/Netlify.png";
import Postman from "../Tech Stacks Images/Postman.png";
import Thunder from "../Tech Stacks Images/Thunder.png";
import Codepen from "../Tech Stacks Images/Codepen.png";
import Vercel from "../Tech Stacks Images/Vercel.png";
import Replit from "../Tech Stacks Images/Replit.png";

function Skills() {
  const useStyles = makeStyles({
    all: {
      "&:hover": {
        backgroundColor: "rgb(10 10 10)",
        scale: "1.04",
        transition: "scale 0.7s ease-out",
      },
    },
  });

  const classes = useStyles();

  return (
    <Box
      sx={{
        color: "white",
        margin: "auto",
        backgroundColor: "black",
        boxSizing: "border-box",
        width:"100vw",
        paddingBottom:'80px'
      }}
    >
      <Box
        sx={{
          width: '90vw',
          margin: "auto",
          textAlign: "justify",
          fontSize: "55px",
          color: "teal",
          boxSizing: "border-box",
          marginTop:{lg:"75px",md:"75px",sm:"40px",xs:"0px"},
          padding:{lg:"0px",md:"0px",sm:"30px 0px 0px 0px",xs:"70px 0px 0px 0px"}
        }}
      >
        Front End
        <hr />
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {lg:"repeat(3,1fr)",md:"repeat(2,1fr)",sm:"repeat(1,1fr)"},
          gap: "55px",
          width: '80vw',
          margin: "auto",
          padding: "30px",
        }}
      >
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(204 102 0)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={html}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>HTML</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(102 178 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={css}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>CSS</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(255 255 0)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={javascript}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>
            JavaScript
          </Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(0 204 204)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={react}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>ReactJS</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px #66b2ff" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={TypeScript}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>TypeScript</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(178 102 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={redux}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>Redux</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(255 255 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={NextJS}
            sx={{ width: "150px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>NextJS</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(102 178 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={MaterialUI}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>Material UI</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(0 153 153)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={ChakraUI}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>Chakra UI</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          margin: "auto",
          textAlign: "justify",
          fontSize: "55px",
          color: "teal",
          width: '90vw',
          marginTop:{lg:"100px",md:"80px",sm:"60px",xs:"60px"},
          padding:{lg:"0px",md:"0px",sm:"0px 0px",xs:"0px 0px"}
        }}
      >
        Back End
        <hr />
      </Box>
      <Box
        sx={{
          display: "grid",
          gap: "55px",
          margin: "auto",
          padding: "30px",
          gridTemplateColumns: {lg:"repeat(3,1fr)",md:"repeat(2,1fr)",sm:"repeat(1,1fr)"},
          width: '80vw',
        }}
      >
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(178 255 102)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={node}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>NodeJS</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(255 255 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={express}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>
            ExpressJS
          </Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(128 255 0)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={mongodb}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>MongoDB</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          margin: "auto",
          textAlign: "justify",
          fontSize: "55px",
          color: "teal",
          width: '90vw',
          marginTop:{lg:"100px",md:"80px",sm:"60px",xs:"60px"},
          padding:{lg:"0px",md:"0px",sm:"0px 0px",xs:"0px 0px"}
        }}
      >
        Tools
        <hr />
      </Box>
      <Box
        sx={{
          display: "grid",
          gap: "55px",
          margin: "auto",
          padding: "30px",
          gridTemplateColumns: {lg:"repeat(3,1fr)",md:"repeat(2,1fr)",sm:"repeat(1,1fr)"},
          width: '80vw',
        }}
      >
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(102 178 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={VS_Code}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>VS Code</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(255 255 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={github}
            sx={{ width: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>GitHub</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(255 150 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={Thunder}
            sx={{ width: "100px", height: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>
            Thunder Client
          </Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(0 153 153)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={Netlify}
            sx={{ width: "100px", height: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>Netlify</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(255 255 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={CodeSandbox}
            sx={{ width: "100px", height: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>
            CodeSandbox
          </Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(255 160 102)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={Postman}
            sx={{ width: "100px", height: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>Postman</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(255 255 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={Vercel}
            sx={{ width: "100px", height: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>Vercel</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(200 200 220)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={Replit}
            sx={{ width: "100px", height: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>Replit</Typography>
        </Box>
        <Box
          sx={{ boxShadow: "1px 1px 10px rgba(255 255 255)" }}
          className={classes.all}
        >
          <Box
            component="img"
            src={Codepen}
            sx={{ width: "100px", height: "100px", padding: "20px" }}
          ></Box>
          <Typography sx={{ padding: "0px 0px 20px 0px" }}>CodePen</Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default Skills;
